import { PropertySpyCreateForm } from 'features/propertySpy/propertySpyCreate/ui/PropertySpyCreateForm'
import { useAppDispatch } from '../../../../../shared/hooks';
import { setMainBarSettings, setParentUrl } from '../../../../../store/applicationSlice';
import { useEffect } from 'react';

export const PropertySpyCreatePage = (): JSX.Element => {
    const dispatch = useAppDispatch()
    useEffect(() => {
        dispatch(setMainBarSettings({
            back: {
                url: '/property'
            },
            title: 'Create Property Spies',
            showProfileButton: false
        }))
        dispatch(setParentUrl(`/property`))

        return () => {
            dispatch(setMainBarSettings(undefined))
            dispatch(setParentUrl(undefined))
        }
    });

    return (
        <>
            <PropertySpyCreateForm
            />
        </>
    )
}